import { useDataModel } from '@thd-nucleus/data-sources';

export const useSubmitHelpful = (formData) => {
  const [submitHelpful, response] = useDataModel('submitReviewFeedback', {
    variables: formData,
    lazy: true,
  });
  return [submitHelpful, response];
};
